module.exports = __webpack_public_path__ + "static/media/icon-finder.0f7ddc24.png";